import React from 'react';
import './Footer.css';

const Footer = ({ assetBaseUrl }) => {
  return (
    <>
      <div className="bMtdM">
        <div className="cTxeDb">
          <div className="bbOsHr">
            <div className="bPvfCa">
              <img 
                src={`${assetBaseUrl}/Footer.jpg`} 
                title="" 
                className="bVMQJK" 
                alt="footer logo" 
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="hOKUVn">
        <div className="cTxeDb">
          <div className="kmwXth">
            <nav className="dmBfxJ">
              <ul className="djdlCe">
                <li className="joeWD">
                  <a href="https://modelmediaasia.com/zh-CN/information/terms" 
                     rel="nofollow noreferrer" 
                     className="hiiXds" 
                     target="_blank">TERMS AND CONDITIONS</a>
                </li>
                <li className="joeWD">
                  <a href="https://modelmediaasia.com/zh-CN/information/privacy" 
                     rel="nofollow noreferrer" 
                     className="hiiXds" 
                     target="_blank">PRIVACY POLICY</a>
                </li>
                <li className="joeWD">
                  <a href="https://modelmediaasia.com/zh-CN/information/contact-us" 
                     rel="nofollow noreferrer" 
                     className="hiiXds" 
                     target="_blank">Contact Us</a>
                </li>
              </ul>
            </nav>
            <div className="gfhBML">
              <p className="gzolOg">©2022 Model Media. All rights Reserved</p>
              <p className="gzolOg">
                All models appearing on this website are 18 years or older. Click 
                <a href="https://www.modelmediaasia.com/zh-CN/information/2257" rel="noreferrer">here</a> 
                for records required pursuant to 18 U.S.C. 2257 Record Keeping Requirements Compliance Statement.
              </p>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Footer; 